/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: StartModuleRedirect.tsx
 🗓️ Created: 2025-01-10
 🧩 Description:
    Component that redirects users to their configured start module
    or to the default dashboard if no start module is configured.

 🔧 Notes:
    - Reads user.startModuleUrl from auth store
    - Falls back to /dashboard if no start module configured
    - Automatically loads the start module's menu section

 🔁 Last Updated: 2025-01-10 by Rodrigo Cuadra
────────────────────────────────────────────────────────────────*/

import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth';

export const StartModuleRedirect = () => {
  const { user } = useAuthStore();

  // Get the configured start module URL or default to dashboard
  const startUrl = user?.startModuleUrl || '/dashboard';

  // IMPORTANTE: No cargar el menú aquí - el Sidebar ya lo hace de forma lazy
  // Solo redirigir al módulo de inicio configurado

  return <Navigate to={startUrl} replace />;
};

